import { routes } from '@/shared/routes';

import { execute, modelId } from '@/front/actions/utils';
import { POST } from '@/front/fetch';

export const resendSigningRequest = async () => {
  const requestId = modelId();

  if (requestId) {
    await execute(POST, routes.requests.resendSigning({ id: requestId }));
  }
};
